<div class="content">
  <div class="content__header">
    <div class="content__header__logo w-64">
      <img src="assets/images/logos/field_logo.svg" />
    </div>
    <h1 class="content__header__title">
      <span> {{ 'NET_PROMOTER_SCORE.FINAL_STEP.TITLE_1' | translate }} </span>
      <span> {{ 'NET_PROMOTER_SCORE.FINAL_STEP.TITLE_2' | translate }} </span>
      <span> {{ 'NET_PROMOTER_SCORE.FINAL_STEP.TITLE_3' | translate }} </span>
    </h1>
  </div>
  <div class="content__container">
    <button mat-stroked-button (click)="nextStep()" type="button" class="content__container__next_button">
      {{ 'NET_PROMOTER_SCORE.BUTTONS.CLOSE' | translate }}
    </button>
  </div>
</div>
